import React from 'react';
import InfoText from '../../../atoms/InfoText';
import Search from '../../../categories/Search';

type Props = {
  title: string;
  subTitle?: string;
  hasSearch?: boolean;
  searchName?: string;
  actions?: React.ReactElement;
  mobileTopRight?: React.ReactElement;
  children: React.ReactElement;
  dataTestId?: string;
  searchPlaceholder?: string;
  inlineSearchOnMobile?: boolean;
};

export default function TableWrapper({
  title,
  subTitle,
  hasSearch,
  searchName,
  actions,
  mobileTopRight,
  children,
  dataTestId = 'table-wrapper',
  searchPlaceholder,
  inlineSearchOnMobile,
}: Props) {
  return (
    <div
      className="p-6 rounded-xl border border-gray-200 dark:border-dark-border bg-white dark:bg-dark-surface flex flex-col gap-6 my-2 shadow-sm"
      data-testid={dataTestId}
    >
      <div className="flex flex-col gap-2 md:gap-0 md:flex-row md:items-center md:justify-between">
        {/* Left side */}
        <div className="flex justify-between items-start md:block w-full md:w-auto">
          <div>
            <InfoText
              text={title}
              className="!text-[#090909] !text-lg !font-bold dark:!text-dark-text-primary"
            />

            {subTitle && <InfoText text={subTitle} className="!text-gray-500 text-sm" />}
          </div>
          {mobileTopRight && (
            <div className="md:hidden">
              {mobileTopRight}
            </div>
          )}
        </div>

        {/* Right side */}
        <div className={inlineSearchOnMobile ? "flex gap-2 items-center w-full md:w-auto" : "flex flex-col gap-2 sm:flex-row sm:items-center"}>
          {hasSearch && searchName && (
            <div className={inlineSearchOnMobile ? "flex-1" : ""}>
              <Search searchName={searchName} inputWidth="!w-full sm:!w-[280px] !h-[44px] !border-[#E7E7E9] dark:!border-dark-border !rounded-lg" />
            </div>
          )}
          {actions}
        </div>
      </div>

      {children}
    </div>
  );
}
